import { render, staticRenderFns } from "./PriceInfoDialog.vue?vue&type=template&id=5f6d0ed6&scoped=true"
import script from "./PriceInfoDialog.vue?vue&type=script&lang=ts"
export * from "./PriceInfoDialog.vue?vue&type=script&lang=ts"
import style0 from "./PriceInfoDialog.vue?vue&type=style&index=0&id=5f6d0ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6d0ed6",
  null
  
)

export default component.exports